<template>
  <!-- Modal -->
  <div class="modal fade" id="modal-hesab-code" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content rounded text-dark">
        <div class="modal-header bg-primary text-white rounded-top p-2">
          <h5 class="modal-title" id="exampleModalLabel">لیست کد حساب ها</h5>
          <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- شروع تب حساب ها -->
          <div class="col p-0">
            <!-- تب های کد حساب -->
            <ul class="nav nav-tabs">
              <!-- تب لیست حساب ها -->
              <li class="nav-item activeNav rounded-top">
                <a href="#tabHesab-list" id="home-tab" class="
                    nav-link
                    active
                    d-flex
                    justify-content-between
                    align-items-center
                  " data-toggle="tab">
                  لیست حساب ها ( {{ TbBaseAccDataFilter.length | numFormat }} مورد )
                </a>
              </li>
              <!-- تب درختواه حساب ها -->
              <!-- <li class="nav-item rounded-top">
                <a
                  href="#tabHesab-tree"
                  id="profile-tab"
                  class="nav-link d-flex justify-content-between align-items-center"
                  data-toggle="tab"
                >
                  درختواره حساب ها
                </a>
              </li> -->
            </ul>

            <!-- بدنه تب های حساب ها -->
            <div class="tab-content rounded shadow z-depth-1 p-1">
              <!-- بدنه تب لیست حساب ها -->
              <div class="tab-pane fade show active w-100" id="tabHesab-list">
                <!-- جدول محتویات -->
                <div class="row p-2 justify-content-center">
                  <div id="TbBaseAccData" class="table-responsive" style="max-height: 280px; overflow-y: auto">
                    <table class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                      ">
                      <!-- سربرگ جدول -->
                      <thead>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          ردیف
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          کد حساب
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          عنوان حساب
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          کل
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          معین 1
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          معین 2
                        </td>
                        <td class="bg-primary-light" style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          ">
                          طرف حساب
                        </td>
                      </thead>
                      <!-- بدنه جدول -->
                      <tbody>
                        <tr v-for="(row, index) in getListDataPaging" :key="row.NCode"
                          :class="{ selRow: selectRowID == row.NCode }" style="cursor: pointer;"
                          v-on:click="selectRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
                          v-on:dblclick="dblClickRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
                          v-bind:id="row.NCode">
                          <td style="
                              max-width: 50px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.RowID }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.NCode }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.SDesc }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.GA }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.CA1 }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{ row.CA2 }}
                          </td>
                          <td style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            ">
                            {{
                              row.NAccType === 0
                              ? "اختیاری (" + row.NAccType + ")"
                              : row.NAccType === 2
                                ? "اجباری (" + row.NAccType + ")"
                                : "ندارد (" + row.NAccType + ")"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <PaginationHesabCode class="mt-2" 
                    v-bind:Name="'HesabCode'" 
                    v-bind:CountRow="intCountRow"
                    v-bind:DataRepository="TbBaseAccDataFilter" 
                    v-on:ChangePage="ChangePage"></PaginationHesabCode>
                </div>
              </div>

              <!-- بدنه تب درختواره حساب ها -->
              <!-- <div class="tab-pane fade w-100" id="tabHesab-tree">
                <div class="row">
                  
                  <mdb-treeview class="border-0 text-right" animated>
                    <mdb-treeview-item nested animated far title="افتتاحیه">
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="حساب افتتاحیه"
                      />
                    </mdb-treeview-item>
                    <mdb-treeview-item far nested animated title="نقد و بانک">
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="بانک ها"
                      />
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="تنخواه گردان"
                      />
                    </mdb-treeview-item>
                  </mdb-treeview>
                  
                </div>
              </div> -->
            </div>
          </div>
          <!-- پایان تب حساب ها -->
        </div>
        <div class="modal-footer bg-primary-light p-2">
          <div class="col-6 flex-fill">
            <div class="input-group px-1">
              <input 
                type="text" 
                autocomplete="off" 
                id="textHesabSearch" 
                placeholder="جستجو در کد و عنوان حساب (Enter)"
                class="form-control form-control-sm rounded-0" 
                v-on:focus="$event.target.select()"
                v-on:keyup.enter="filterData($event.target.value, $event); $event.target.select()" />
              <div class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    bg-primary
                    rounded-left
                    white-text
                  ">
                  <a v-on:click="filterData('Search')">
                    <i class="fas fa-search"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="col-6 text-left">
            <button type="button" title="F4 انتخاب" class="btn btn-primary" v-on:click="SelectHesab()">
              انتخاب حساب (F4)
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   mdbContainer,
//   mdbRow,
//   mdbIcon,
//   mdbTreeview,
//   mdbTreeviewItem,
//   mdbtable,
// } from "mdbvue";

import { BusEvent } from "../../../../../main.js";
import PaginationHesabCode from "../../PublicComponents/Pagination.vue"

export default {
  components: {
    PaginationHesabCode
  },
  data() {
    return {
      selectRowID: 0,
      selectRowType: 0,
      selectRowSDesc: "",
      selectRowNPerID: 0,

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 100,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

      // TbBaseAccDataTitel: [
      //   { key: "NCode", label: "کد حساب", sortable: true },
      //   { key: "SDesc", label: "عنوان حساب", sortable: true },
      //   { key: "GA", label: "کل", sortable: true },
      //   { key: "CA1", label: "معین 1", sortable: true },
      //   { key: "CA2", label: "معین 2", sortable: true },
      // ],
      // ایندکس سطر در حال انتخاب
      indexRow: 0,
      // مخزن اصلی داده ها
      TbBaseAccData: [],
      // مخزن داده های فیلتر شده
      TbBaseAccDataFilter: [],

      NCodeSearch: [],
    };
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbBaseAccDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbBaseAccDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  mounted() {
    // بررسی انصراف از نمایش مودال
    $("#modal-hesab-code").on("hidden.bs.modal", this.HideModal);
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    // لغو مودال کد حساب و طرف حساب
    HideModal() {
      // لحظه بسته شدن مودال
      if (this.selectRowID == 0) {
        this.$emit("HideModal", { NCode: 0, SDesc: "", NAccType: 0, NPerID: 0 });
      } else {
        console.log('hide ...', this.selectRowSDesc);
        this.$emit("HideModal", {
          NCode: this.selectRowID,
          SDesc: this.selectRowSDesc,
          NAccType: this.selectRowType,
          NPerID: this.selectRowNPerID
        });
      }
    },

    // فیلتر لیست حساب ها
    async filterData(searchValue, event) {
      if (searchValue === "Search") {
        searchValue =
          $("#textHesabSearch").val() != "" ?
            $("#textHesabSearch").val()
            : "";
      }

      // لغو فراخوانی جستجو در صورت کلیک فلش بالا و پایین
      try {
        if (event.key.toString() === "ArrowDown" || event.key.toString() === "ArrowUp") {
          $("#textHesabSearch").select();
          console.log('ok ...');
          return true;
        }
      } catch (e) { }

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        this.TbBaseAccDataFilter =
          this.TbBaseAccData.filter(function (item) {
            return (item.NCode.toString().startsWith(searchValue) ||
              item.SDesc.toString().includes(searchValue))
          });
        if (this.TbBaseAccDataFilter.length > 0) {
          // درج شماره ردیف برای لیست
          this.TbBaseAccDataFilter = await this.$store.dispatch('setRowIDForList', this.TbBaseAccDataFilter);
          if (this.TbBaseAccDataFilter.length < this.indexRow) this.indexRow = 0;
          // ذخیره سطر پیدا شده
          this.selectRowID = this.TbBaseAccDataFilter[this.indexRow].NCode;
          this.selectRowSDesc = this.TbBaseAccDataFilter[this.indexRow].SDesc;
          this.selectRowType = this.TbBaseAccDataFilter[this.indexRow].NAccType;
          this.selectRowNPerID = this.TbBaseAccDataFilter[this.indexRow].NPerID;
        }
      } else {
        this.TbBaseAccDataFilter = this.TbBaseAccData;
      }
    },

    // جستجو در لیست حساب ها
    // searchData(searchValue, event) {
    //   if (searchValue != "") {
    //     // جستجوی مقدار درج شده توسط کاربر
    //     // و انتقال نمایش به سطر جستجو شده
    //     // به تقاضای آقای گل محمدی با فیلتر جایگزین شد 1400/09/20
    //     let index = this.TbBaseAccData.findIndex(
    //       (item) =>
    //         item.NCode.toString().startsWith(searchValue) ||
    //         item.SDesc.toString().includes(searchValue)
    //     );
    //     if (index != -1) {
    //       let NCode = this.TbBaseAccData[index].NCode;
    //       $("#" + NCode).scrollintoview({
    //         duration: 500,
    //         //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
    //       });
    //       // ذخیره سطر پیدا شده
    //       this.selectRowID = this.TbBaseAccData[index].NCode;
    //       this.selectRowSDesc = this.TbBaseAccData[index].SDesc;
    //       this.selectRowType = this.TbBaseAccData[index].NAccType;
    //     }
    //   }
    // },

    async getTbBaseAccData() {
      if (this.TbBaseAccData.length == 0) {
        this.TbBaseAccData = await this.$store.getters.getTbBaseAccData;
        this.TbBaseAccDataFilter = this.TbBaseAccData;
      }
    },

    dblClickRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRow(NCode, SDesc, NAccType, NPerID);
      this.SelectHesab();
    },

    selectRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRowID = NCode;
      this.selectRowSDesc = SDesc;
      this.selectRowType = NAccType;
      this.selectRowNPerID = NPerID;
    },

    SelectHesab() {
      if (this.selectRowID == 0) {
        this.$store.dispatch("notify", {
          notText:
            "حسابی در حالت انتخاب نیست !\nلطفا ابتدا یکی از حساب ها را در حالت انتخاب قرار دهید .",
          timeOut: 2500,
        });
      } else {
        this.NCodeSearch = [];
        // بستن مودال
        $("#modal-hesab-code").modal("hide");
      }
    },

    setFocusTextSearch(value) {
      setTimeout(() => {
        $("#textHesabSearch").focus();
        if (value != "") {
          $("#textHesabSearch").val(value);
          $("#textHesabSearch").select();
          this.filterData('Search');
        }
      }, 200);
    },
    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      if (this.TbBaseAccDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbBaseAccDataFilter.findIndex(
            (item) => item.NCode == this.selectRowID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index - 1].NCode,
                  this.TbBaseAccDataFilter[index - 1].SDesc,
                  this.TbBaseAccDataFilter[index - 1].NAccType,
                  this.TbBaseAccDataFilter[index - 1].NPerID
                );
                $("#" + this.TbBaseAccDataFilter[index - 1].NCode).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index - 1;
              }
            } else {
              if (index + 1 < this.TbBaseAccDataFilter.length) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index + 1].NCode,
                  this.TbBaseAccDataFilter[index + 1].SDesc,
                  this.TbBaseAccDataFilter[index + 1].NAccType,
                  this.TbBaseAccDataFilter[index + 1].NPerID
                );
                $("#" + this.TbBaseAccDataFilter[index + 1].NCode).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index + 1;
              }
            }
          } else {
            this.selectRow(
              this.TbBaseAccDataFilter[0].NCode,
              this.TbBaseAccDataFilter[0].SDesc,
              this.TbBaseAccDataFilter[0].NAccType,
              this.TbBaseAccDataFilter[0].NPerID
            );
            this.indexRow = 0;
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    this.getTbBaseAccData();
    BusEvent.$on("setFocusetextHesabSearch", this.setFocusTextSearch);
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    BusEvent.$off("setFocusetextHesabSearch", this.setFocusTextSearch);
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/ModalHesabCode.vue